import { getProduct, getProductIdFromSlug } from '$lib/product';
import { getResponseErrorCode, withDependencies } from '$lib/api';
import { getUsernameAndTestAppId } from '$lib/url';
import type { PageLoad } from './$types';
import { error } from '@sveltejs/kit';

export const load: PageLoad = async ({ params, fetch }) => {
  return withDependencies(async () => {
    const [, testAppId] = getUsernameAndTestAppId(params.username);

    const productId = getProductIdFromSlug(params.productSlug);

    try {
      const { product, gates } = await getProduct(fetch, productId, testAppId);

      const currentDate = new Date();
      const isLive =
        currentDate >= new Date(product.liveAt) ||
        (product.previewAt && currentDate >= new Date(product.previewAt));

      if (!isLive) throw error(404);

      return {
        product,
        gates,
        isTestMode: !!testAppId,
      };
    } catch (e) {
      if (getResponseErrorCode(e) === 404) {
        throw error(404);
      }

      return {
        isTestMode: !!testAppId,
      };
    }
  });
};
